import { Container } from 'react-bootstrap';
import Galeriaa from '../../components/galeria/Galeriaa';

const galerias = [
  {
    titulo: 'Fotos Turma 1',
    imagens: [
      'assets/galeria/turma1/handson005.jpg',
      'assets/galeria/turma1/handson001.jpg',
      'assets/galeria/turma1/handson002.jpg',
      'assets/galeria/turma1/handson003.jpg',
      'assets/galeria/turma1/handson004.jpg',
    ],
  },
  {
    titulo: 'Fotos Turma 2',
    imagens: [
      'assets/galeria/turma2/handson001.jpg',
      'assets/galeria/turma2/handson005.jpg',
      'assets/galeria/turma2/handson006.jpg',
      'assets/galeria/turma2/handson007.jpg',
      'assets/galeria/turma2/handson008.jpg',
    ],
  },
  {
    titulo: 'Fotos Turma 3',
    imagens: [
      'assets/galeria/turma3/handson001.jpg',
      'assets/galeria/turma3/handson002.jpg',
      'assets/galeria/turma3/handson003.jpg',
      'assets/galeria/turma3/handson004.jpg',
      'assets/galeria/turma3/handson005.jpg',
    ],
  },
  {
    titulo: 'Fotos Turma 4',
    imagens: [
      'assets/galeria/turma4/handson005.jpg',
      'assets/galeria/turma4/handson001.jpg',
      'assets/galeria/turma4/handson002.jpg',
      'assets/galeria/turma4/handson003.jpg',
      'assets/galeria/turma4/handson004.jpg',
    ],
  },
  {
    titulo: 'Fotos Turma 5',
    imagens: [
      'assets/galeria/turma5/handson001.jpg',
      'assets/galeria/turma5/handson002.jpg',
      'assets/galeria/turma5/handson003.jpg',
      'assets/galeria/turma5/handson004.jpg',
      'assets/galeria/turma5/handson005.jpg',
      'assets/galeria/turma5/handson006.jpg',
    ],
  },
  {
    titulo: 'Fotos da Turma 1 - EaD (Benjamin Constant, Tabatinga & Itacoatira)',
    imagens: [
      'assets/galeria/turma1_ead/turma1_ead.jpeg',
      'assets/galeria/turma1_ead/conecta_1.png',
      'assets/galeria/turma1_ead/conecta_3.png',
      'assets/galeria/turma1_ead/conecta_2.png',
      'assets/galeria/turma1_ead/matis_1.png',
      'assets/galeria/turma1_ead/matis_3.png',
      'assets/galeria/turma1_ead/matis_2.png'

    ],
  },
  {
    titulo: 'Fotos da Turma 6',
    imagens: [
      'assets/galeria/turma6/IMG_3065.png',
      'assets/galeria/turma6/2026-03-30_17-16.png',
      'assets/galeria/turma6/2026-03-30_17-17.png',  
      'assets/galeria/turma6/2026-03-30_17-18.png',
      'assets/galeria/turma6/2026-03-30_17-18_1.png',
      'assets/galeria/turma6/2026-03-30_17-27.png',  
      'assets/galeria/turma6/2026-03-30_17-19.png',
      'assets/galeria/turma6/2026-03-30_17-19_1.png',
      'assets/galeria/turma6/2026-03-30_17-20.png',
      'assets/galeria/turma6/2026-03-30_17-21.png',     
      'assets/galeria/turma6/IMG_20260326_215601717_HDR.jpg'
    ],
  },
];

function Galeria() {
  return (
    <Container>
      <div className="row g-3 justify-content-center mb-5">
        <div className="col-md-12">
          {/* <h3 style={{ marginTop: '50px' }}>Galeria de Fotos</h3>*/}
          {/* <p>Conheça os produtos desenvolvidos na disciplina de Hands-on</p>*/}
          <Galeriaa galerias={galerias} />
        </div>
      </div>
    </Container>
  );
}

export default Galeria;
